<div class="map-layer-container" #mapContainer>
  <!-- Map fills entire container -->
  <app-sites-location-map
    #siteMap
    class="map-content"
    [projectLayersInSidenav]="true"
    [fullscreenElement]="fullscreenElement"
    [dateRange]="dateRange"
    [hoveredSiteId]="hoveredSiteId"
    [hoveredBidItemId]="hoveredBidItemId"
    [hoveredDate]="hoveredDate"
    [hoveredInspectorId]="hoveredInspectorId"
    [selectedSiteIds]="selectedSiteIdsForHighlight"
    [selectedBidItemIds]="selectedBidItemIdsForHighlight"
    [selectedInspectorIds]="selectedInspectorIdsForHighlight"
    [selectedDates]="selectedDatesForHighlight"
    [viewBy]="selectedViewBy"
    [bidItemsWithGeometries]="bidItemsWithGeometries"
    [datesWithReports]="datesWithReports"
    [availableInspectors]="availableInspectors"
    [availableFormGroups]="availableFormGroups"
    [labelConfig]="labelConfig"
    [linkedOnly]="linkedOnly"
    (fullscreenChange)="onFullscreenChange($event)"
    (layerChange)="onLayerChange($event)"
    (typeFilterChange)="onTypeFilterChange($event)"
    (geometryClick)="onGeometryClick($event)"
  ></app-sites-location-map>

  <!-- Test mode floating button — only visible when localStorage.__test_mode__ is 'true' -->
  @if (testMode) {
    <button
      data-testid="map-test-click-geometry"
      class="test-mode-btn"
      (click)="onTestGeometryClick()"
    >Test: Click Geometry</button>
  }

  <!-- Floating UI elements (only visible in fullscreen) -->
  @if (isFullScreen && (!isWarrantyClaimsMode && !isPunchlistMode && !isIssuesMode || (showClaimDetail && selectedClaim) || (showIssueDetail && selectedIssue) || (showPunchlistItemDetail && selectedPunchlistItem))) {
    <!-- Sidenav panel -->
    <div class="floating-sidenav-panel">
      @if (showClaimDetail && selectedClaim) {
        <app-claim-detail-sidenav
          [projectId]="projectId"
          [claim]="selectedClaim"
          (closed)="closeClaimDetail()"
        ></app-claim-detail-sidenav>
      } @else if (showIssueDetail && selectedIssue) {
        <app-issue-detail-sidenav
          [projectId]="projectId"
          [issue]="selectedIssue"
          (closed)="closeIssueDetail()"
        ></app-issue-detail-sidenav>
      } @else if (showPunchlistItemDetail && selectedPunchlistItem) {
        <div class="punchlist-item-host">
          <button class="punchlist-close-btn" (click)="closePunchlistItemDetail()" aria-label="Close">
            <mat-icon>close</mat-icon>
          </button>
          <app-punchlist-item-detail
            [data]="selectedPunchlistItem"
            [readOnly]="true"
          ></app-punchlist-item-detail>
          <div class="punchlist-host-footer">
            <app-primary-button (handleClick)="openPunchlistItemInSidenav()" class="w-full">
              Open
            </app-primary-button>
          </div>
        </div>
      } @else {
        <app-map-sidenav
          [showDesignTab]="true"
          [projectLayers]="siteMap.toolbarState"
          [canManageLayers]="siteMap.canManageProjectLayers"
          (projectLayerToggle)="siteMap.onToolbarOverlayToggle($event)"
          (projectLayerOpacity)="siteMap.onOverlayOpacityChange($event)"
          (projectLayerLabels)="siteMap.onOverlayLabelsToggle($event)"
          (projectLayerZoom)="siteMap.zoomToOverlayIfOffscreen($event)"
          (projectLayersReset)="siteMap.resetProjectLayerView()"
          (projectLayersRetry)="siteMap.refreshOverlays()"
          (projectLayerSwipe)="siteMap.onToolbarSwipePresetChange($event)"
          [projectId]="projectId"
          [filteredSites]="filteredSites"
          [availableSites]="availableSites"
          [availableBidItems]="availableBidItems"
          [availableFormGroups]="availableFormGroups"
          [formGroupMode]="true"
          [bidItemsWithGeometries]="bidItemsWithGeometries"
          [selectedBidItemIds]="selectedBidItemIds"
          [availableInspectors]="availableInspectors"
          [layerSettings]="layerSettings"
          [initialTypeFilters]="selectedTypeFilters"
          (searchChange)="onSearchChange($event)"
          (dateRangeChange)="onDateRangeChange($event)"
          (viewModeChange)="onViewModeChange($event)"
          (viewByChange)="onViewByChange($event)"
          (siteHover)="onSiteHover($event)"
          (bidItemHover)="onBidItemHover($event)"
          (dateHover)="onDateHover($event)"
          (inspectorHover)="onInspectorHover($event)"
          (siteSelectionChange)="onSiteSelectionChange($event)"
          (bidItemSelectionChange)="onBidItemSelectionChange($event)"
          (inspectorSelectionChange)="onInspectorSelectionChange($event)"
          (dateSelectionChange)="onDateSelectionChange($event)"
          (layerChange)="onLayerChange($event)"
          (typeFilterChange)="onTypeFilterChange($event)"
          (siteFilterChange)="onSiteFilterChange($event)"
          (bidItemFilterChange)="onBidItemFilterChange($event)"
          [labelsEnabled]="labelsEnabled"
          [labelBy]="labelBy"
          (labelToggle)="onLabelToggle()"
          (labelByChange)="onLabelByChange($event)"
        ></app-map-sidenav>
      }
    </div>
  }

  <!-- Picture overlay (always available, visibility controlled by component) -->
  <app-picture-overlay></app-picture-overlay>
</div>
